// Libraries
var React = require('react');

// Styles
require('./Subscribe.scss');

class SubscribeModule extends React.Component {
	render() {
		const link = this.props.data.subscribeLink;
		if(!link) {
			return;
		}
		return (		
			<div className={"newsletter-subscription"}>
				<div className={"newsletter-subscription__wrapper"}>
					<p className="newsletter-subscription__label">{this.props.data.subscribeLabel}</p>
					<a className="newsletter-subscription__button" href={link.url} target={link.newWindow ? "_blank" : "_self"} rel={link.newWindow ? "noopener noreferrer" : undefined}>{link.caption}</a>
				</div>
			</div>
		)
	}
}

module.exports = SubscribeModule;



// WEBPACK FOOTER //
// ./src/components/Footer/Subscribe/SubscribeModule.js